<template>
  <ChipLabelInput
    :value="value"
    :chip-types="chipTypes"
    :chip-tooltip="companyScopes.length ? 'When sent as a scoped report, the scope label(s) will be inserted here' : ''"
    :placeholder="placeholder"
    @input="$emit('input', $event)" />
</template>

<script>
  import ChipLabelInput from '@/components/pdf_report/ChipLabelInput.vue'

  export default {
    name: 'ScopeLabelInput',
    components: { ChipLabelInput, },
    props: {
      value: {
        type: String,
        default: '',
      },
      placeholder: {
        type: String,
        default: 'Name',
      },
      scopes: {
        type: Array,
        default: null,
      },
    },
    data () {
      return {
        loadedScopes: [],
      }
    },
    computed: {
      companyScopes () {
        return this.scopes || this.loadedScopes
      },
      chipTypes () {
        return this.companyScopes.map((s) => ({
          placeholder: `{{${s.key}}}`,
          label: s.name,
        }))
      },
    },
    async mounted () {
      if (this.scopes) return
      try {
        const result = await this.$apis.companyConfigs.listCompanyScopes()
        this.loadedScopes = result || []
      } catch (e) {
        this.loadedScopes = []
      }
    },
  }
</script>
